import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import arrowRight from "../assets/images/bet-frenzy/arrowRight.svg";
import arrowLeft from "../assets/images/bet-frenzy/arrowLeft.svg";
import { useDispatch, useSelector } from "react-redux";
import { getDreamCasinoGames } from "../redux/slices/games/casino/dreamCasinoGameListSlice";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function LiveCasinoCarousel({
  setIsPopupOpen,
  setSelectedGame,
}) {
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: profileData } = useSelector((state) => state.getProfile);

  const [games, setGames] = useState([]);
  const [isLeftDisabled, setIsLeftDisabled] = useState(true);
  const [isRightDisabled, setIsRightDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const scrollAmount = 250; // pixels to scroll

  const scroll = (direction) => {
    if (!carouselRef.current) return;

    carouselRef.current.scrollBy({
      left: direction == "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const container = carouselRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      setIsLeftDisabled(scrollLeft <= 5);
      setIsRightDisabled(scrollLeft >= maxScrollLeft - 5);
    };

    // Listen to scroll events
    container.addEventListener("scroll", handleScroll);

    // Run on mount to set initial button state
    handleScroll();

    // Cleanup
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [games]);
  const [count, setCount] = useState(0);

  const getData = (pageNumber) => {
    setIsLoading(true);
    dispatch(
      getDreamCasinoGames({
        page: 1,
        limit: 20,
        perpage: 20,
        search_by_category: "live",
        search_by_provider: "", // betgames
        search_by_text: "",
        is_popular: 0,
        parent_user_id: profileData?.user?.parent_user_id,
      })
    )
      .unwrap()
      .then((res) => {
        setCount(res.totalCount);
        // setAll((prev) => [...prev, ...res.data]);
        // setGames(res.data);

        const validatedGames = res?.data?.map((game) => ({
          ...game,
          isBroken: false, // flag for broken thumbnails
        }));

        validatedGames?.forEach((game, idx) => {
          const img = new Image();
          img.src = game?.url_thumb;

          img.onload = () => {
            setGames((prev) => {
              const copy = [...prev];
              copy[idx] = { ...game, isBroken: false }; // ✅ valid image
              return copy;
            });
          };

          img.onerror = () => {
            setGames((prev) => {
              const copy = [...prev];
              copy[idx] = { ...game, isBroken: true }; // ❌ broken → mark
              return copy;
            });
          };
        });
      })
      .catch((error) => {
        // toast.error(error.message);
        console.error("Failed :", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData(1);
  }, []);

  return (
    <div className="carousel-container">
      <div className="carousel-header align-items-start d-flex flex-column flex-sm-column flex-md-column flex-lg-row">
        <h4
          className="fw-medium hero-heading text-capitalize color-CCD6F6 mt-3 mb-2 fs-20 w-25"
          style={{ minWidth: "300px" }}
        >
          Live Casino
        </h4>

        <div
          className=" mt-0 mt-xs-0 mt-sm-0 mt-md-0 mt-lg-3 mb-2 d-flex w-100 justify-content-between justify-content-sm-between 
             justify-content-md-between justify-content-lg-end"
        >
          <span
            className="see-all align-content-center"
            onClick={() => {
              navigate(`/casino-games/live`, {
                state: { category: "", name: "live", sidebar_cat: "live" },
              });
              // navigate("live-casino-games/popular-casino");
            }}
          >
            See all <span className="ms-2 text-gray">({count})</span>{" "}
          </span>
          <div className="d-flex">
            <span
              className={`nav-btn-ft mx-1 left d-flex justify-content-center align-items-center ${
                isLeftDisabled ? "disabled-arrow" : ""
              }`}
              onClick={() => {
                if (!isLeftDisabled) scroll("left");
              }}
            >
              <img
                src={arrowLeft}
                width={15}
                alt="Left"
                style={{ filter: isLeftDisabled ? "grayscale(100%)" : "none" }}
                loading="lazy"
              />
            </span>
            <span
              className={`nav-btn-ft mx-1 right d-flex justify-content-center align-items-center ${
                isRightDisabled ? "disabled-arrow" : ""
              }`}
              onClick={() => {
                if (!isRightDisabled) scroll("right");
              }}
            >
              <img
                src={arrowRight}
                width={15}
                alt="Right"
                style={{ filter: isRightDisabled ? "grayscale(100%)" : "none" }}
                loading="lazy"
              />
            </span>
          </div>
        </div>
      </div>

      <div className="carousel-wrapper justify-content-center">
        <div className="carousel-wrap-live casino-home-wrap" ref={carouselRef}>
          {isLoading ? (
            <SkeletonTheme baseColor="#2a2d3e" highlightColor="#3e4259">
              {[...Array(8)].map((_, i) => (
                <Skeleton
                  key={i}
                  width={320}
                  height={190}
                  style={{
                    borderRadius: "20px",
                    margin: "5px",
                  }}
                />
              ))}
            </SkeletonTheme>
          ) : games?.length > 0 ? (
            games.map((game, index) => (
             
                <img
                className="game-card-live-casino align-content-center cursor-pointer"
                key={index}
                onClick={() => {
                  if (profileData) {
                    setSelectedGame(game);
                    setIsPopupOpen(true);
                    // navigate("/game-launch", {
                    //   state: { game_id: game?._id, game: game },
                    // });
                  } else {
                    navigate("/");
                    sessionStorage.setItem("fromLogin", "true");
                  }
                }}
                draggable="false"
                src={game?.url_thumb}
                alt={game?.game_name}
                loading="lazy"
                style={{
                  border: game?.isBroken ? "1px solid #3a3f5c" : "",
                  borderRadius: "20px",
                  display: game?.isBroken ? "block" : "",
                  alignContent: game?.isBroken ? "center" : "",
                  background: game?.isBroken ? "rgba(245, 247, 250, 0.12)" : "",
                }}
              />
               
             
            ))
          ) : (
            <span className="d-flex align-items-center text-white">
              No Data Found
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
